import http from '@/services/http';
import { BLOG_ARTICLE_PAGE, BLOG_CATEGORY_BLOCK, BLOG_CATEGORY_LANDING_PAGE } from '@/constants/categoryPage';
import { SearchReq } from '@/type/pages';
import axios from 'axios';
import { error } from '@/utils/safetyLog';

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;
export const getCateTags = async (language: string = 'zh-hk') => {
  try {
    const res = await axios.get(APP_BASE_URL + '/contentstack/cateTags', {
      params: { language },
    });
    return res;
  } catch (e) {
    error('getCateTags error: ', e);
  }
};

export const getProductTags = async (language: string = 'zh-hk') => {
  try {
    const res = await axios.get(APP_BASE_URL + '/contentstack/productTags', {
      params: { language },
    });

    return res;
  } catch (e) {
    error('getProductTags error:', e);
  }
};

export const getAllCategory = async (localLanguage: string = 'zh-hk') => {
  try {
    return await http({}).post(`/contentstack/${BLOG_CATEGORY_BLOCK}`, {
      queryObj: {},
      includeReference: [],
      language: localLanguage,
    });
  } catch (e) {
    error('getAllCategory error:', e);
    return { data: [] }; // fallback to avoid undefined
  }
};

export const getAllCategoryLanding = async (localLanguage: string = 'zh-hk') => {
  try {
    return await http({}).post(`/contentstack/${BLOG_CATEGORY_LANDING_PAGE}`, {
      queryObj: {},
      includeReference: [
        'category_reference',
        'display_card.blog_collection.blog',
        'promotional_banner.banner_reference',
      ],
      language: localLanguage,
    });
  } catch (e) {
    error('getAllCategoryLanding error:', e);
    return { data: [] };
  }
};

const defSearchReq: SearchReq = {
  page: 1,
  pageSize: 9,
  language: 'zh-hk',
  sortBy: 'publishDate',
  topicTagEntryIds: [],
  prodTagEntryIds: [],
};

export const getCategoryPage = async (requestData: SearchReq = {}) => {
  try {
    return http({}).post(`/contentstack/page/${BLOG_ARTICLE_PAGE}`, {
      includeReference: ['blog_snippet.topic_tags', 'blog_snippet.product_tags', 'blog_snippet.category'],
      ...defSearchReq,
      ...requestData,
    });
  } catch (e) {
    error('getCategoryPage error:', e);
    return { data: [] };
  }
};

export const getCategoryLandingPage = () => {};
